/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtochangepausereasoninloginmask9Inputs */

const en_entity_isuserallowedtochangepausereasoninloginmask9 = /** @type {(inputs: Entity_Isuserallowedtochangepausereasoninloginmask9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Change Pause Reason In Login Mask`)
};

const de_entity_isuserallowedtochangepausereasoninloginmask9 = /** @type {(inputs: Entity_Isuserallowedtochangepausereasoninloginmask9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Pausengrund in Loginmaske ändern`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Change Pause Reason In Login Mask" |
*
* @param {Entity_Isuserallowedtochangepausereasoninloginmask9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtochangepausereasoninloginmask9 = /** @type {((inputs?: Entity_Isuserallowedtochangepausereasoninloginmask9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtochangepausereasoninloginmask9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtochangepausereasoninloginmask9(inputs)
	return de_entity_isuserallowedtochangepausereasoninloginmask9(inputs)
});
export { entity_isuserallowedtochangepausereasoninloginmask9 as "entity_isUserAllowedToChangePauseReasonInLoginMask" }